/**
 * Property API functions
 *
 * Uses bridge for now, will call backend directly once updated
 */

import {
  getProperty as bridgeGetProperty,
  getPropertyList as bridgeGetPropertyList,
  createProperty as bridgeCreateProperty,
  updateProperty as bridgeUpdateProperty,
  deleteProperty as bridgeDeleteProperty,
} from "./bridge";
import type { Property } from "@/lib/types/property";

/**
 * Get a single property by ID
 */
export async function getProperty(
  propertyId: string,
  token: string
): Promise<Property> {
  return await bridgeGetProperty(propertyId, token);
}

/**
 * Get all properties for the authenticated user
 */
async function getPropertyList(token: string): Promise<Property[]> {
  return await bridgeGetPropertyList(token);
}

/**
 * Create a new property
 */
async function createProperty(
  name: string,
  domain: string,
  token: string
): Promise<Property> {
  return await bridgeCreateProperty(name, domain, token);
}

/**
 * Update property details
 */
async function updateProperty(
  propertyId: string,
  updates: { name?: string },
  token: string
): Promise<Property> {
  return await bridgeUpdateProperty(propertyId, updates, token);
}

/**
 * Delete a property
 */
async function deleteProperty(
  propertyId: string,
  token: string
): Promise<{ success: boolean }> {
  return await bridgeDeleteProperty(propertyId, token);
}
